import { render, staticRenderFns } from "./MobileDetail.vue?vue&type=template&id=fe301222&scoped=true"
import script from "./MobileDetail.vue?vue&type=script&lang=js"
export * from "./MobileDetail.vue?vue&type=script&lang=js"
import style0 from "./MobileDetail.vue?vue&type=style&index=0&id=fe301222&prod&scoped=true&lang=css"
import style1 from "./MobileDetail.vue?vue&type=style&index=1&id=fe301222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe301222",
  null
  
)

export default component.exports